import { Component } from '@angular/core';

@Component({
    selector: 'nio-migration-large-texas-hospital',
    templateUrl: './migration-large-texas-hospital.component.html',
    styleUrls: ['./migration-large-texas-hospital.component.scss'],
    standalone: false
})
export class MigrationLargeTexasHospitalComponent {}
